module.exports = __webpack_public_path__ + "img/Ale_Tosser_demo.9301f878.gif";